import { render, staticRenderFns } from "./anatomie.vue?vue&type=template&id=10df886d&"
import script from "./anatomie.vue?vue&type=script&lang=js&"
export * from "./anatomie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports